<template>
  <div>
    <h5 class="mb-3">
      <strong>Basic</strong>
    </h5>
    <div class="mb-5">
      <a-spin tip="Cargando..." />
    </div>
  </div>
</template>
<script>
export default {
  name: 'KitAntdSpinExample',
}
</script>
